import React from 'react';
import CommissionWorkflowList from './CommissionWorkflowList';

export default function CommissionApprovalPage(props) { return <CommissionWorkflowList mode="approval" {...props} />; }
